module.exports = __webpack_public_path__ + "media/images/booth/watermark-0c257d95f7d29385ae51a73d56a585ba.png";